/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table2.js";
import Table1 from "components/Table/Table.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
// import PaginationComponent from "react-reactstrap-pagination";
import Pagination from "react-responsive-pagination";
import "bootstrap/dist/css/bootstrap.min.css";
import { CardFooter } from "reactstrap";
import TSSelect from "components/Forms/TSSelect";
import CardIcon from "components/Card/CardIcon.js";
import Icon from "@material-ui/core/Icon";
import AddBox from "@material-ui/icons/AddBox";
import Subject from "@material-ui/icons/Subject";
import styles2 from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import Button from "components/CustomButtons/Button.js";
import { Collapse, Modal, ModalBody } from "reactstrap";
import loading from "assets/img/loading-load.gif";
import axios from "utils/httpClient";

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  cardCategory: {
    marginTop: "0",
    marginBottom: "3px",
    minHeight: "auto"
  },
  cardTitle: {
    marginTop: "0",
    marginBottom: "3px",
    minHeight: "auto"
  }
};

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

export default function TableList() {
  const classes = useStyles();
  const classes2 = useStyles2();
  // const [selectedPage, setSelectedPage] = useState(1);
  const [l1Option, setL1Option] = useState([]);
  const [l2Option, setL2Option] = useState([]);
  const [l3Option, setL3Option] = useState([]);
  const [l4Option, setL4Option] = useState([]);
  const [l1OptionSave, setL1OptionSave] = useState([]);
  const [l2OptionSave, setL2OptionSave] = useState([]);
  const [l3OptionSave, setL3OptionSave] = useState([]);
  const [l4OptionSave, setL4OptionSave] = useState([]);
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const [dataInfo, setDataInfo] = useState([]);
  const [option1, setOption1] = useState("");
  const [option2, setOption2] = useState("");
  const [option3, setOption3] = useState("");
  const [option4, setOption4] = useState("");
  const [option1Save, setOption1Save] = useState("");
  const [option2Save, setOption2Save] = useState("");
  const [option3Save, setOption3Save] = useState("");
  const [option4Save, setOption4Save] = useState("");
  const [oldOption1, setOldOption1] = useState("");
  const [oldOption2, setOldOption2] = useState("");
  const [oldOption3, setOldOption3] = useState("");
  const [oldOption4, setOldOption4] = useState("");
  const [oldOption1Save, setOldOption1Save] = useState("");
  const [oldOption2Save, setOldOption2Save] = useState("");
  const [oldOption3Save, setOldOption3Save] = useState("");
  const [oldOption4Save, setOldOption4Save] = useState("");
  const [disable1, setDisable1] = useState(true);
  const [disable2, setDisable2] = useState(true);
  const [disable3, setDisable3] = useState(true);
  const [disable1Save, setDisable1Save] = useState(true);
  const [disable2Save, setDisable2Save] = useState(true);
  const [disable3Save, setDisable3Save] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage2, setCurrentPage2] = useState(1);
  const [totalPages2, setTotalPages2] = useState(1);
  const [pageSize] = useState(10);
  const windowWidth = useWindowWidth();
  const [tableHead, setTableHead] = useState([]);
  const [tableHead2, setTableHead2] = useState([]);
  const [selected, setSelected] = useState([]);
  const [modal, setModal] = useState(false);
  const [errMsg, setErrMsg] = useState([]);
  const [modalError, setModalError] = useState(false);
  const [icon, setIcon] = useState("far fa-question-circle");
  const [isOpen, setIsOpen] = useState(false);
  const [select, setSelect] = useState([]);
  const [year, setYear] = useState([]);
  const [isShow, setIsShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);

  var currentUser = JSON.parse(localStorage.getItem('currentUser'))

  const onSelected = e => {
    setSelected(e);
  };

  const handleSubmit = evt => {
    evt.preventDefault();
    var cntErr = 0;

    var errMsg = [];

    if (cntErr > 0) {
      setErrMsg(errMsg);
      setModalError(true);
    } else {
      setModal(true);
    }
  };

  useEffect(() => {

    //   .then(response => response.json())
    //   .then(
    //     result => {
    //       setL1Option(result.data);
    //       setL1OptionSave(result.data);
    //     },
    //     error => {
    //       console.log(error);
    //     }
    //   );

    axios("/api/v1/group1")
    .then(
      result => {
        var res = result.data;
        setL1Option(res.data);
        setL1OptionSave(res.data);
      }, error => {console.log(error);}
    );  
  }, []);

  useEffect(() => {
    if (option1 !== "") {

      //   .then(response => response.json())
      //   .then(
      //     result => {
      //       setL2Option(result.data);
      //       setDisable1(false);
      //       setOldOption1(option1);
      //       if (option1 !== oldOption1) {
      //         setOption2("");
      //         setOption3("");
      //         setDisable2(true);
      //         setDisable3(true);
      //         setL3Option([]);
      //         setData([]);
      //         setIsShow(false);
      //       }
      //     },
      //     error => {
      //       console.log(error);
      //     }
      //   );

      axios("/api/v1/group2/" + option1)
      .then(
        result => {
          var res = result.data;
          setL2Option(res.data);
          setDisable1(false);
          setOldOption1(option1);
          if (option1 !== oldOption1) {
            setOption2("");
            setOption3("");
            setDisable2(true);
            setDisable3(true);
            setL3Option([]);
            setData([]);
            setIsShow(false);
          }
        }, 
        error => {
          console.log(error);
        }
      );  
    }
  }, [option1]);

  useEffect(() => {
    if (option1Save !== "") {

      //   .then(response => response.json())
      //   .then(
      //     result => {
      //       setL2OptionSave(result.data);
      //       setDisable1Save(false);
      //       setOldOption1Save(option1Save);
      //       if (option1Save !== oldOption1Save) {
      //         setOption2Save("");
      //         setOption3Save("");
      //         setOption4Save("");
      //         setDisable2Save(true);
      //         setDisable3Save(true);
      //         setL3OptionSave([]);
      //         setData2([]);
      //         setIsOpen(false);

      //         setOption1("");
      //         setOption2("");
      //         setOption3("");
      //         setOption4("");
      //         setDisable1(true);
      //         setDisable2(true);
      //         setDisable3(true);
      //         setL3Option([]);
      //         setL2Option([]);
      //         setData([]);
      //         setIsShow(false);
      //         setSelect([]);
      //       }
      //     },
      //     error => {
      //       console.log(error);
      //     }
      //   );

      axios("/api/v1/group2/" + option1Save)
      .then(
        result => {
          var res = result.data;
          setL2OptionSave(res.data);
          setDisable1Save(false);
          setOldOption1Save(option1Save);
          if (option1Save !== oldOption1Save) {
            setOption2Save("");
            setOption3Save("");
            setOption4Save("");
            setDisable2Save(true);
            setDisable3Save(true);
            setL3OptionSave([]);
            setData2([]);
            setIsOpen(false);

            setOption1("");
            setOption2("");
            setOption3("");
            setOption4("");
            setDisable1(true);
            setDisable2(true);
            setDisable3(true);
            setL3Option([]);
            setL2Option([]);
            setData([]);
            setIsShow(false);
            setSelect([]);
          }
        }, 
        error => {
          console.log(error);
        }
      );  
    }
  }, [option1Save]);

  useEffect(() => {
    if (option1 === 1 || option1 === 4) {
      if (option2 !== "") {
        axios("/api/v1/subGroup3/" + option2)
          .then(response => response.data)
          .then(
            result => {
              setL3Option(result.data);
              setDisable2(false);
              setOldOption2(option2);
              if (option2 !== oldOption2) {
                setDisable3(true);
                setOption3("");
                setData([]);
                setIsShow(false);
              }
            },
            error => {
              console.log(error);
            }
          );
      }
    } else {
      setOldOption2(option2);
    }
  }, [option2]);

  useEffect(() => {
    if (option1Save === 1 || option1Save === 4) {
      if (option2Save !== "") {
        axios("/api/v1/subGroup3/" + option2Save)
          .then(response => response.data)
          .then(
            result => {
              setL3OptionSave(result.data);
              setDisable2Save(false);
              setOldOption2Save(option2Save);
              if (option2Save !== oldOption2Save) {
                setDisable3Save(true);
                setOption3Save("");
                setData2([]);
                setIsOpen(false);
                setOption4Save("");

                setOption1("");
                setOption2("");
                setOption3("");
                setOption4("");
                setDisable1(true);
                setDisable2(true);
                setDisable3(true);
                setL3Option([]);
                setL2Option([]);
                setData([]);
                setIsShow(false);
                setSelect([]);
              }
            },
            error => {
              console.log(error);
            }
          );
      }
    } else {
      setOldOption2Save(option2Save);
    }
  }, [option2Save]);

  useEffect(() => {
    if (option1 === 4) {
      if (option3 !== "") {
        axios("/api/v1/subGroup4/" + option3)
          .then(response => response.data)
          .then(
            result => {
              setL4Option(result.data);
              setDisable3(false);
              setOldOption3(option3);
              if (option3 !== oldOption3) {
                setOption4("");
                setData([]);
                setIsShow(false);
              }
            },
            error => {
              console.log(error);
            }
          );
      }
    } else {
      setOldOption3(option3);
    }
  }, [option3]);

  useEffect(() => {
    if (option1Save === 4) {
      if (option3Save !== "") {
        axios("/api/v1/subGroup4/" + option3Save)
          .then(response => response.data)
          .then(
            result => {
              setL4OptionSave(result.data);
              setDisable3Save(false);
              setOldOption3Save(option3Save);
              if (option3Save !== oldOption3Save) {
                setOption4Save("");
                setData2([]);
                setIsOpen(false);

                setOption1("");
                setOption2("");
                setOption3("");
                setDisable1(true);
                setDisable2(true);
                setDisable3(true);
                setL3Option([]);
                setL2Option([]);
                setData([]);
                setIsShow(false);
                setOption4("");
                setL4Option("");
                setSelect([]);
              }
            },
            error => {
              console.log(error);
            }
          );
      }
    } else {
      setOldOption3Save(option3Save);
    }
  }, [option3Save]);

  useEffect(() => {
    setOldOption4(option4);
  }, [option4]);

  useEffect(() => {
    setOldOption4Save(option4Save);
  }, [option4Save]);

  useEffect(() => {
    axios("/api/v1/year/")
      .then(response => response.data)
      .then(
        result => {
          tableHead.push(
            "",
            "ชื่อตัวชี้วัด",
            "ค่าเป้าหมาย",
            result[5].label,
            result[4].label,
            result[3].label,
            result[2].label,
            result[1].label,
            result[0].label
          );
          tableHead2.push(
            "ชื่อตัวชี้วัด",
            "ค่าเป้าหมาย",
            result[5].label,
            result[4].label,
            result[3].label,
            result[2].label,
            result[1].label,
            result[0].label
          );
          setYear(result);
        },
        error => {
          console.log(error);
        }
      );
  }, []);

  useEffect(() => {
    if (option1 !== 1 && option1 !== 4) {
      if (option2 !== "") {
        if (option2 !== oldOption2) {
          setCurrentPage(1);
        }
        setIsLoading(true);
        axios(
          "/api/v1/tableSave/" +
            option2 +
            "/pagination?PageNumber=" +
            currentPage +
            "&PageSize=" +
            pageSize
        )
          .then(response => response.data)
          .then(
            result => {
              //setData(result.data);
              var tableList = [];
              if (result.data.length > 0) {
                // if (result.data[0].listData[0].key !== 0) {
                result.data.forEach(e => {
                  if (e.listData.length < 6) {
                    var l1 = [];
                    var name;
                    var target;
                    var dataId;
                    var tags;
                    var j = 0;
                    for (var i = 0; i < 6; i++) {
                      if (
                        e.listData[j] !== undefined &&
                        e.listData[j].key.toString() === year[i].value
                      ) {
                        if (e.showId === 1) {
                          l1 = l1.concat(
                            e.listData[j].value2 === null
                              ? 0
                              : e.listData[j].value2.toFixed(2)
                          );
                        } else if (e.showId === 2) {
                          l1 = l1.concat(e.listData[j].value);
                        }
                        name = e.name;
                        target =
                          e.typeName + " " + Number(e.target).toLocaleString();
                        dataId = e.dataId;
                        tags = e.tags;
                        j++;
                      } else {
                        l1 = l1.concat(0);
                        name = e.name;
                        target =
                          e.typeName + " " + Number(e.target).toLocaleString();
                        dataId = e.dataId;
                        tags = e.tags;
                      }
                    }

                    tableList.push([
                      name,
                      target,
                      l1[5].toLocaleString(),
                      l1[4].toLocaleString(),
                      l1[3].toLocaleString(),
                      l1[2].toLocaleString(),
                      l1[1].toLocaleString(),
                      l1[0].toLocaleString(),
                      (dataId = e.listData[0].dataId),
                      option1,
                      option2,
                      tags
                    ]);
                  } else {
                    if (e.showId === 1 || e.showId === 3) {
                      tableList.push([
                        e.name,
                        e.typeName + " " + Number(e.target).toLocaleString(),
                        e.listData[5] === undefined
                          ? 0
                          : e.listData[5].value2.toFixed(2).toLocaleString(),
                        e.listData[4] === undefined
                          ? 0
                          : e.listData[4].value2.toFixed(2).toLocaleString(),
                        e.listData[3] === undefined
                          ? 0
                          : e.listData[3].value2.toFixed(2).toLocaleString(),
                        e.listData[2] === undefined
                          ? 0
                          : e.listData[2].value2.toFixed(2).toLocaleString(),
                        e.listData[1] === undefined
                          ? 0
                          : e.listData[1].value2.toFixed(2).toLocaleString(),
                        e.listData[0] === undefined
                          ? 0
                          : e.listData[0].value2.toFixed(2).toLocaleString(),
                        e.dataId,
                        option1,
                        option2,
                        e.tags
                      ]);
                    } else if (e.showId === 2 || e.showId === 4) {
                      tableList.push([
                        e.name,
                        e.typeName + " " + Number(e.target).toLocaleString(),
                        e.listData[5] === undefined
                          ? 0
                          : e.listData[5].value.toLocaleString(),
                        e.listData[4] === undefined
                          ? 0
                          : e.listData[4].value.toLocaleString(),
                        e.listData[3] === undefined
                          ? 0
                          : e.listData[3].value.toLocaleString(),
                        e.listData[2] === undefined
                          ? 0
                          : e.listData[2].value.toLocaleString(),
                        e.listData[1] === undefined
                          ? 0
                          : e.listData[1].value.toLocaleString(),
                        e.listData[0] === undefined
                          ? 0
                          : e.listData[0].value.toLocaleString(),
                        e.dataId,
                        option1,
                        option2,
                        e.tags
                      ]);
                    }
                  }
                });
                // } else {
                //   tableList.push([
                //     result.data[0].name,
                //     result.data[0].typeName + " " + result.data[0].target,
                //     0,
                //     0,
                //     0,
                //     0,
                //     0,
                //     0,
                //     result.data[0].dataId,
                //     option1,
                //     option2,
                //     result.data[0].tags
                //   ]);
                // }
              }
              if (option2 === option2Save) {
                setData([]);
                setIsShow(false);
              } else {
                setData(tableList);
                if (tableList.length > 0) {
                  setIsShow(true);
                } else {
                  setIsShow(false);
                }
              }
              var total = result.total / pageSize;
              if (!Number.isInteger(total)) {
                setTotalPages((total | 0) + 1);
              } else if (total === 0) {
                setTotalPages(1);
              } else {
                setTotalPages(total);
              }
              setIsLoading(false);
            },
            error => {
              console.log(error);
              setIsLoading(false);
            }
          );
      }
    }
  }, [option2, currentPage]);

  useEffect(() => {
    if (option1 === 1) {
      if (option3 !== "") {
        if (option3 !== oldOption3) {
          setCurrentPage(1);
        }
        setIsLoading(true);
        axios(
          "/api/v1/table2Save/" +
            option3 +
            "/pagination?PageNumber=" +
            currentPage +
            "&PageSize=" +
            pageSize
        )
          .then(response => response.data)
          .then(
            result => {
              //setData(result.data);
              var tableList = [];
              if (result.data.length > 0) {
                // if (result.data[0].listData[0].key !== 0) {
                result.data.forEach(e => {
                  if (e.listData.length < 6) {
                    var l1 = [];
                    var name;
                    var target;
                    var dataId;
                    var tags;
                    var j = 0;
                    for (var i = 0; i < 6; i++) {
                      if (
                        e.listData[j] !== undefined &&
                        e.listData[j].key.toString() === year[i].value
                      ) {
                        if (e.showId === 1) {
                          l1 = l1.concat(
                            e.listData[j].value2 === null
                              ? 0
                              : e.listData[j].value2.toFixed(2)
                          );
                        } else if (e.showId === 2) {
                          l1 = l1.concat(e.listData[j].value);
                        }
                        name = e.name;
                        target =
                          e.typeName + " " + Number(e.target).toLocaleString();
                        tags = e.tags;
                        dataId = e.dataId;
                        j++;
                      } else {
                        l1 = l1.concat(0);
                        name = e.name;
                        target =
                          e.typeName + " " + Number(e.target).toLocaleString();
                        dataId = e.dataId;
                        tags = e.tags;
                      }
                    }

                    tableList.push([
                      name,
                      target,
                      l1[5].toLocaleString(),
                      l1[4].toLocaleString(),
                      l1[3].toLocaleString(),
                      l1[2].toLocaleString(),
                      l1[1].toLocaleString(),
                      l1[0].toLocaleString(),
                      (dataId = e.listData[0].dataId),
                      option1,
                      option2,
                      option3,
                      tags
                    ]);
                  } else {
                    if (e.showId === 1 || e.showId === 3) {
                      tableList.push([
                        e.name,
                        e.typeName + " " + Number(e.target).toLocaleString(),
                        e.listData[5] === undefined
                          ? 0
                          : e.listData[5].value2.toFixed(2).toLocaleString(),
                        e.listData[4] === undefined
                          ? 0
                          : e.listData[4].value2.toFixed(2).toLocaleString(),
                        e.listData[3] === undefined
                          ? 0
                          : e.listData[3].value2.toFixed(2).toLocaleString(),
                        e.listData[2] === undefined
                          ? 0
                          : e.listData[2].value2.toFixed(2).toLocaleString(),
                        e.listData[1] === undefined
                          ? 0
                          : e.listData[1].value2.toFixed(2).toLocaleString(),
                        e.listData[0] === undefined
                          ? 0
                          : e.listData[0].value2.toFixed(2).toLocaleString(),
                        e.dataId,
                        option1,
                        option2,
                        option3,
                        e.tags
                      ]);
                    } else if (e.showId === 2 || e.showId === 4) {
                      tableList.push([
                        e.name,
                        e.typeName + " " + Number(e.target).toLocaleString(),
                        e.listData[5] === undefined
                          ? 0
                          : e.listData[5].value.toLocaleString(),
                        e.listData[4] === undefined
                          ? 0
                          : e.listData[4].value.toLocaleString(),
                        e.listData[3] === undefined
                          ? 0
                          : e.listData[3].value.toLocaleString(),
                        e.listData[2] === undefined
                          ? 0
                          : e.listData[2].value.toLocaleString(),
                        e.listData[1] === undefined
                          ? 0
                          : e.listData[1].value.toLocaleString(),
                        e.listData[0] === undefined
                          ? 0
                          : e.listData[0].value.toLocaleString(),
                        e.dataId,
                        option1,
                        option2,
                        option3,
                        e.tags
                      ]);
                    }
                  }
                });
                // } else {
                //   tableList.push([
                //     result.data[0].name,
                //     result.data[0].typeName + " " + result.data[0].target,
                //     0,
                //     0,
                //     0,
                //     0,
                //     0,
                //     0,
                //     result.data[0].dataId,
                //     option1,
                //     option2,
                //     option3,
                //     result.data[0].tags
                //   ]);
                // }
              }
              if (option3 === option3Save) {
                setData([]);
                setIsShow(false);
              } else {
                setData(tableList);
                if (tableList.length > 0) {
                  setIsShow(true);
                } else {
                  setIsShow(false);
                }
              }
              var total = result.total / pageSize;
              if (!Number.isInteger(total)) {
                setTotalPages((total | 0) + 1);
              } else if (total === 0) {
                setTotalPages(1);
              } else {
                setTotalPages(total);
              }
              setIsLoading(false);
            },
            error => {
              console.log(error);
              setIsLoading(false);
            }
          );
      }
    }
  }, [option3, currentPage]);

  useEffect(() => {
    if (option1 === 4) {
      if (option4 !== "") {
        if (option4 !== oldOption4) {
          setCurrentPage(1);
        }
        setIsLoading(true);
        axios(
          "/api/v1/table3Save/" +
            option4 +
            "/pagination?PageNumber=" +
            currentPage +
            "&PageSize=" +
            pageSize
        )
          .then(response => response.data)
          .then(
            result => {
              //setData(result.data);
              var tableList = [];
              if (result.data.length > 0) {
                // if (result.data[0].listData[0].key !== 0) {
                result.data.forEach(e => {
                  if (e.listData.length < 6) {
                    var l1 = [];
                    var name;
                    var target;
                    var dataId;
                    var tags;
                    var j = 0;
                    for (var i = 0; i < 6; i++) {
                      if (
                        e.listData[j] !== undefined &&
                        e.listData[j].key.toString() === year[i].value
                      ) {
                        if (e.showId === 1) {
                          l1 = l1.concat(
                            e.listData[j].value2 === null
                              ? 0
                              : e.listData[j].value2.toFixed(2)
                          );
                        } else if (e.showId === 2) {
                          l1 = l1.concat(e.listData[j].value);
                        }
                        name = e.name;
                        target =
                          e.typeName + " " + Number(e.target).toLocaleString();
                        tags = e.tags;
                        dataId = e.dataId;
                        j++;
                      } else {
                        l1 = l1.concat(0);
                        name = e.name;
                        target =
                          e.typeName + " " + Number(e.target).toLocaleString();
                        dataId = e.dataId;
                        tags = e.tags;
                      }
                    }

                    tableList.push([
                      name,
                      target,
                      l1[5].toLocaleString(),
                      l1[4].toLocaleString(),
                      l1[3].toLocaleString(),
                      l1[2].toLocaleString(),
                      l1[1].toLocaleString(),
                      l1[0].toLocaleString(),
                      (dataId = e.listData[0].dataId),
                      option1,
                      option2,
                      option3,
                      option4,
                      tags
                    ]);
                  } else {
                    if (e.showId === 1 || e.showId === 3) {
                      tableList.push([
                        e.name,
                        e.typeName + " " + Number(e.target).toLocaleString(),
                        e.listData[5] === undefined
                          ? 0
                          : e.listData[5].value2.toFixed(2).toLocaleString(),
                        e.listData[4] === undefined
                          ? 0
                          : e.listData[4].value2.toFixed(2).toLocaleString(),
                        e.listData[3] === undefined
                          ? 0
                          : e.listData[3].value2.toFixed(2).toLocaleString(),
                        e.listData[2] === undefined
                          ? 0
                          : e.listData[2].value2.toFixed(2).toLocaleString(),
                        e.listData[1] === undefined
                          ? 0
                          : e.listData[1].value2.toFixed(2).toLocaleString(),
                        e.listData[0] === undefined
                          ? 0
                          : e.listData[0].value2.toFixed(2).toLocaleString(),
                        e.dataId,
                        option1,
                        option2,
                        option3,
                        option4,
                        e.tags
                      ]);
                    } else if (e.showId === 2 || e.showId === 4) {
                      tableList.push([
                        e.name,
                        e.typeName + " " + Number(e.target).toLocaleString(),
                        e.listData[5] === undefined
                          ? 0
                          : e.listData[5].value.toLocaleString(),
                        e.listData[4] === undefined
                          ? 0
                          : e.listData[4].value.toLocaleString(),
                        e.listData[3] === undefined
                          ? 0
                          : e.listData[3].value.toLocaleString(),
                        e.listData[2] === undefined
                          ? 0
                          : e.listData[2].value.toLocaleString(),
                        e.listData[1] === undefined
                          ? 0
                          : e.listData[1].value.toLocaleString(),
                        e.listData[0] === undefined
                          ? 0
                          : e.listData[0].value.toLocaleString(),
                        e.dataId,
                        option1,
                        option2,
                        option3,
                        option4,
                        e.tags
                      ]);
                    }
                  }
                });
                // } else {
                //   tableList.push([
                //     result.data[0].name,
                //     result.data[0].typeName + " " + result.data[0].target,
                //     0,
                //     0,
                //     0,
                //     0,
                //     0,
                //     0,
                //     result.data[0].dataId,
                //     option1,
                //     option2,
                //     option3,
                //     option4,
                //     result.data[0].tags
                //   ]);
                // }
              }
              if (option4 === option4Save) {
                setData([]);
                setIsShow(false);
              } else {
                setData(tableList);
                if (tableList.length > 0) {
                  setIsShow(true);
                } else {
                  setIsShow(false);
                }
              }
              var total = result.total / pageSize;
              if (!Number.isInteger(total)) {
                setTotalPages((total | 0) + 1);
              } else if (total === 0) {
                setTotalPages(1);
              } else {
                setTotalPages(total);
              }
              setIsLoading(false);
            },
            error => {
              console.log(error);
              setIsLoading(false);
            }
          );
      }
    }
  }, [option4, currentPage]);

  useEffect(() => {
    if (option1Save !== 1 && option1Save !== 4) {
      if (option2Save !== "") {
        if (option2Save !== oldOption2Save) {
          setCurrentPage2(1);
        }
        setIsLoading2(true);
        axios(
          "/api/v1/table/" +
            option2Save +
            "/pagination?PageNumber=" +
            currentPage2 +
            "&PageSize=" +
            pageSize
        )
          .then(response => response.data)
          .then(
            result => {
              //setData(result.data);
              setIsOpen(true);
              var tableList = [];
              if (result.data.length > 0) {
                // if (result.data[0].listData[0].key !== 0) {
                result.data.forEach(e => {
                  if (e.listData.length < 6) {
                    var l1 = [];
                    var name;
                    var target;
                    var dataId;
                    var tags;
                    var j = 0;
                    for (var i = 0; i < 6; i++) {
                      if (
                        e.listData[j] !== undefined &&
                        e.listData[j].key.toString() === year[i].value
                      ) {
                        if (e.showId === 1) {
                          l1 = l1.concat(
                            e.listData[j].value2 === null
                              ? 0
                              : e.listData[j].value2.toFixed(2)
                          );
                        } else if (e.showId === 2) {
                          l1 = l1.concat(e.listData[j].value);
                        }
                        name = e.name;
                        target =
                          e.typeName + " " + Number(e.target).toLocaleString();
                        dataId = e.dataId;
                        tags = e.tags;
                        j++;
                      } else {
                        l1 = l1.concat(0);
                        name = e.name;
                        target =
                          e.typeName + " " + Number(e.target).toLocaleString();
                        dataId = e.dataId;
                        tags = e.tags;
                      }
                    }

                    tableList.push([
                      name,
                      target,
                      l1[5].toLocaleString(),
                      l1[4].toLocaleString(),
                      l1[3].toLocaleString(),
                      l1[2].toLocaleString(),
                      l1[1].toLocaleString(),
                      l1[0].toLocaleString(),
                      e.dataId,
                      option1Save,
                      option2Save,
                      tags
                    ]);
                  } else {
                    if (e.showId === 1 || e.showId === 3) {
                      tableList.push([
                        e.name,
                        e.typeName + " " + Number(e.target).toLocaleString(),
                        e.listData[5] === undefined
                          ? 0
                          : e.listData[5].value2.toFixed(2).toLocaleString(),
                        e.listData[4] === undefined
                          ? 0
                          : e.listData[4].value2.toFixed(2).toLocaleString(),
                        e.listData[3] === undefined
                          ? 0
                          : e.listData[3].value2.toFixed(2).toLocaleString(),
                        e.listData[2] === undefined
                          ? 0
                          : e.listData[2].value2.toFixed(2).toLocaleString(),
                        e.listData[1] === undefined
                          ? 0
                          : e.listData[1].value2.toFixed(2).toLocaleString(),
                        e.listData[0] === undefined
                          ? 0
                          : e.listData[0].value2.toFixed(2).toLocaleString(),
                        e.dataId,
                        option1Save,
                        option2Save,
                        e.tags
                      ]);
                    } else if (e.showId === 2 || e.showId === 4) {
                      tableList.push([
                        e.name,
                        e.typeName + " " + Number(e.target).toLocaleString(),
                        e.listData[5] === undefined
                          ? 0
                          : e.listData[5].value.toLocaleString(),
                        e.listData[4] === undefined
                          ? 0
                          : e.listData[4].value.toLocaleString(),
                        e.listData[3] === undefined
                          ? 0
                          : e.listData[3].value.toLocaleString(),
                        e.listData[2] === undefined
                          ? 0
                          : e.listData[2].value.toLocaleString(),
                        e.listData[1] === undefined
                          ? 0
                          : e.listData[1].value.toLocaleString(),
                        e.listData[0] === undefined
                          ? 0
                          : e.listData[0].value.toLocaleString(),
                        e.dataId,
                        option1Save,
                        option2Save,
                        e.tags
                      ]);
                    }
                  }
                });
                // } else {
                //   tableList.push([
                //     result.data[0].name,
                //     result.data[0].typeName + " " + result.data[0].target,
                //     0,
                //     0,
                //     0,
                //     0,
                //     0,
                //     0,
                //     result.data[0].dataId,
                //     option1Save,
                //     option2Save,
                //     result.data[0].tags
                //   ]);
                // }
              }

              axios(
                "/api/v1/checkReport?group1=" +
                  option1Save +
                  "&group2=" +
                  option2Save +
                  "&group3=" +
                  option3Save +
                  "&group4=" +
                  option4Save,
                {
                  method: "GET"
                }
              )
                .then(response => response.data)
                .then(
                  result => {
                    var list = [];
                    if (
                      result.data.reportSub !== null &&
                      result.data.reportSub.length > 0
                    ) {
                      result.data.reportSub.forEach(e => {
                        list.push([e.dataId]);
                      });
                      setSelect(result.data.reportSub);
                    } else {
                      setSelect([]);
                    }
                  },
                  error => {
                    console.log(error);
                  }
                );

              setData2(tableList);
              var total = result.total / pageSize;
              if (!Number.isInteger(total)) {
                setTotalPages2((total | 0) + 1);
              } else if (total === 0) {
                setTotalPages2(1);
              } else {
                setTotalPages2(total);
              }
              setIsLoading2(false);
            },
            error => {
              setIsLoading2(false);
              console.log(error);
            }
          );
      }
    }
  }, [option2Save, currentPage2]);

  useEffect(() => {
    if (option1Save === 1) {
      if (option3Save !== "") {
        if (option3Save !== oldOption3Save) {
          setCurrentPage2(1);
        }
        setIsLoading2(true);
        axios(
          "/api/v1/table2/" +
            option3Save +
            "/pagination?PageNumber=" +
            currentPage2 +
            "&PageSize=" +
            pageSize
        )
          .then(response => response.data)
          .then(
            result => {
              setIsOpen(true);
              //setData(result.data);
              var tableList = [];
              if (result.data.length > 0) {
                // if (result.data[0].listData[0].key !== 0) {
                result.data.forEach(e => {
                  if (e.listData.length < 6) {
                    var l1 = [];
                    var name;
                    var target;
                    var dataId;
                    var tags;
                    var j = 0;
                    for (var i = 0; i < 6; i++) {
                      if (
                        e.listData[j] !== undefined &&
                        e.listData[j].key.toString() === year[i].value
                      ) {
                        if (e.showId === 1) {
                          l1 = l1.concat(
                            e.listData[j].value2 === null
                              ? 0
                              : e.listData[j].value2.toFixed(2)
                          );
                        } else if (e.showId === 2) {
                          l1 = l1.concat(e.listData[j].value);
                        }
                        name = e.name;
                        target =
                          e.typeName + " " + Number(e.target).toLocaleString();
                        dataId = e.dataId;
                        tags = e.tags;
                        j++;
                      } else {
                        l1 = l1.concat(0);
                        name = e.name;
                        target =
                          e.typeName + " " + Number(e.target).toLocaleString();
                        dataId = e.dataId;
                        tags = e.tags;
                      }
                    }

                    tableList.push([
                      name,
                      target,
                      l1[5].toLocaleString(),
                      l1[4].toLocaleString(),
                      l1[3].toLocaleString(),
                      l1[2].toLocaleString(),
                      l1[1].toLocaleString(),
                      l1[0].toLocaleString(),
                      dataId,
                      option1Save,
                      option2Save,
                      option3Save,
                      tags
                    ]);
                  } else {
                    if (e.showId === 1 || e.showId === 3) {
                      tableList.push([
                        e.name,
                        e.typeName + " " + Number(e.target).toLocaleString(),
                        e.listData[5] === undefined
                          ? 0
                          : e.listData[5].value2.toFixed(2).toLocaleString(),
                        e.listData[4] === undefined
                          ? 0
                          : e.listData[4].value2.toFixed(2).toLocaleString(),
                        e.listData[3] === undefined
                          ? 0
                          : e.listData[3].value2.toFixed(2).toLocaleString(),
                        e.listData[2] === undefined
                          ? 0
                          : e.listData[2].value2.toFixed(2).toLocaleString(),
                        e.listData[1] === undefined
                          ? 0
                          : e.listData[1].value2.toFixed(2).toLocaleString(),
                        e.listData[0] === undefined
                          ? 0
                          : e.listData[0].value2.toFixed(2).toLocaleString(),
                        e.dataId,
                        option1Save,
                        option2Save,
                        option3Save,
                        e.tags
                      ]);
                    } else if (e.showId === 2 || e.showId === 4) {
                      tableList.push([
                        e.name,
                        e.typeName + " " + Number(e.target).toLocaleString(),
                        e.listData[5] === undefined
                          ? 0
                          : e.listData[5].value.toLocaleString(),
                        e.listData[4] === undefined
                          ? 0
                          : e.listData[4].value.toLocaleString(),
                        e.listData[3] === undefined
                          ? 0
                          : e.listData[3].value.toLocaleString(),
                        e.listData[2] === undefined
                          ? 0
                          : e.listData[2].value.toLocaleString(),
                        e.listData[1] === undefined
                          ? 0
                          : e.listData[1].value.toLocaleString(),
                        e.listData[0] === undefined
                          ? 0
                          : e.listData[0].value.toLocaleString(),
                        e.dataId,
                        option1Save,
                        option2Save,
                        option3Save,
                        e.tags
                      ]);
                    }
                  }
                });
                // } else {
                //   tableList.push([
                //     result.data[0].name,
                //     result.data[0].typeName + " " + result.data[0].target,
                //     0,
                //     0,
                //     0,
                //     0,
                //     0,
                //     0,
                //     result.data[0].dataId,
                //     option1Save,
                //     option2Save,
                //     option3Save,
                //     result.data[0].tags
                //   ]);
                // }
              }

              axios(
                "/api/v1/checkReport?group1=" +
                  option1Save +
                  "&group2=" +
                  option2Save +
                  "&group3=" +
                  option3Save +
                  "&group4=" +
                  option4Save,
                {
                  method: "GET"
                }
              )
                .then(response => response.data)
                .then(
                  result => {
                    var list = [];
                    if (
                      result.data.reportSub !== null &&
                      result.data.reportSub.length > 0
                    ) {
                      result.data.reportSub.forEach(e => {
                        list.push([e.dataId]);
                      });
                      setSelect(result.data.reportSub);
                    } else {
                      setSelect([]);
                    }
                  },
                  error => {
                    console.log(error);
                  }
                );

              setData2(tableList);
              var total = result.total / pageSize;
              if (!Number.isInteger(total)) {
                setTotalPages2((total | 0) + 1);
              } else if (total === 0) {
                setTotalPages2(1);
              } else {
                setTotalPages2(total);
              }
              setIsLoading2(false);
            },
            error => {
              setIsLoading2(false);
              console.log(error);
            }
          );
      }
    }
  }, [option3Save, currentPage2]);

  useEffect(() => {
    if (option1Save === 4) {
      if (option4Save !== "") {
        if (option4Save !== oldOption4Save) {
          setCurrentPage2(1);
        }
        setIsLoading2(true);
        axios(
          "/api/v1/table3/" +
            option4Save +
            "/pagination?PageNumber=" +
            currentPage2 +
            "&PageSize=" +
            pageSize
        )
          .then(response => response.data)
          .then(
            result => {
              setIsOpen(true);
              //setData(result.data);
              var tableList = [];
              if (result.data.length > 0) {
                // if (result.data[0].listData[0].key !== 0) {
                result.data.forEach(e => {
                  if (e.listData.length < 6) {
                    var l1 = [];
                    var name;
                    var target;
                    var dataId;
                    var tags;
                    var j = 0;
                    for (var i = 0; i < 6; i++) {
                      if (
                        e.listData[j] !== undefined &&
                        e.listData[j].key.toString() === year[i].value
                      ) {
                        if (e.showId === 1) {
                          l1 = l1.concat(
                            e.listData[j].value2 === null
                              ? 0
                              : e.listData[j].value2.toFixed(2)
                          );
                        } else if (e.showId === 2) {
                          l1 = l1.concat(e.listData[j].value);
                        }
                        name = e.name;
                        target =
                          e.typeName + " " + Number(e.target).toLocaleString();
                        dataId = e.dataId;
                        tags = e.tags;
                        j++;
                      } else {
                        l1 = l1.concat(0);
                        name = e.name;
                        target =
                          e.typeName + " " + Number(e.target).toLocaleString();
                        dataId = e.dataId;
                        tags = e.tags;
                      }
                    }

                    tableList.push([
                      name,
                      target,
                      l1[5].toLocaleString(),
                      l1[4].toLocaleString(),
                      l1[3].toLocaleString(),
                      l1[2].toLocaleString(),
                      l1[1].toLocaleString(),
                      l1[0].toLocaleString(),
                      dataId,
                      option1Save,
                      option2Save,
                      option3Save,
                      option4Save,
                      tags
                    ]);
                  } else {
                    if (e.showId === 1 || e.showId === 3) {
                      tableList.push([
                        e.name,
                        e.typeName + " " + Number(e.target).toLocaleString(),
                        e.listData[5] === undefined
                          ? 0
                          : e.listData[5].value2.toFixed(2).toLocaleString(),
                        e.listData[4] === undefined
                          ? 0
                          : e.listData[4].value2.toFixed(2).toLocaleString(),
                        e.listData[3] === undefined
                          ? 0
                          : e.listData[3].value2.toFixed(2).toLocaleString(),
                        e.listData[2] === undefined
                          ? 0
                          : e.listData[2].value2.toFixed(2).toLocaleString(),
                        e.listData[1] === undefined
                          ? 0
                          : e.listData[1].value2.toFixed(2).toLocaleString(),
                        e.listData[0] === undefined
                          ? 0
                          : e.listData[0].value2.toFixed(2).toLocaleString(),
                        e.dataId,
                        option1Save,
                        option2Save,
                        option3Save,
                        option4Save,
                        e.tags
                      ]);
                    } else if (e.showId === 2 || e.showId === 4) {
                      tableList.push([
                        e.name,
                        e.typeName + " " + Number(e.target).toLocaleString(),
                        e.listData[5] === undefined
                          ? 0
                          : e.listData[5].value.toLocaleString(),
                        e.listData[4] === undefined
                          ? 0
                          : e.listData[4].value.toLocaleString(),
                        e.listData[3] === undefined
                          ? 0
                          : e.listData[3].value.toLocaleString(),
                        e.listData[2] === undefined
                          ? 0
                          : e.listData[2].value.toLocaleString(),
                        e.listData[1] === undefined
                          ? 0
                          : e.listData[1].value.toLocaleString(),
                        e.listData[0] === undefined
                          ? 0
                          : e.listData[0].value.toLocaleString(),
                        e.dataId,
                        option1Save,
                        option2Save,
                        option3Save,
                        option4Save,
                        e.tags
                      ]);
                    }
                  }
                });
                // } else {
                //   tableList.push([
                //     result.data[0].name,
                //     result.data[0].typeName + " " + result.data[0].target,
                //     0,
                //     0,
                //     0,
                //     0,
                //     0,
                //     0,
                //     result.data[0].dataId,
                //     option1Save,
                //     option2Save,
                //     option3Save,
                //     option4Save,
                //     result.data[0].tags
                //   ]);
                // }
              }

              axios(
                "/api/v1/checkReport?group1=" +
                  option1Save +
                  "&group2=" +
                  option2Save +
                  "&group3=" +
                  option3Save +
                  "&group4=" +
                  option4Save,
                {
                  method: "GET"
                }
              )
                .then(response => response.data)
                .then(
                  result => {
                    var list = [];
                    if (
                      result.data.reportSub !== null &&
                      result.data.reportSub.length > 0
                    ) {
                      result.data.reportSub.forEach(e => {
                        list.push([e.dataId]);
                      });
                      setSelect(result.data.reportSub);
                    } else {
                      setSelect([]);
                    }
                  },
                  error => {
                    console.log(error);
                  }
                );

              setData2(tableList);
              var total = result.total / pageSize;
              if (!Number.isInteger(total)) {
                setTotalPages2((total | 0) + 1);
              } else if (total === 0) {
                setTotalPages2(1);
              } else {
                setTotalPages2(total);
              }
              setIsLoading2(false);
            },
            error => {
              setIsLoading2(false);
              console.log(error);
            }
          );
      }
    }
  }, [option4Save, currentPage2]);

  const isCheck = () => {
    if (option1 !== oldOption1) {
      return [{ value: "", label: "" }];
    }
  };

  const isCheck2 = () => {
    if (option2 !== oldOption2) {
      return [{ value: "", label: "" }];
    }
  };

  const isCheck3 = () => {
    if (option3 !== oldOption3) {
      return [{ value: "", label: "" }];
    }
  };

  const isCheck4 = () => {
    if (option1Save !== oldOption1Save) {
      return [{ value: "", label: "" }];
    }
  };

  const isCheck5 = () => {
    if (option2Save !== oldOption2Save) {
      return [{ value: "", label: "" }];
    }
  };

  const isCheck6 = () => {
    if (option3Save !== oldOption3Save) {
      return [{ value: "", label: "" }];
    }
  };

  function useWindowWidth() {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth - 400);

    useEffect(() => {
      const resizeHandler = () => {
        setWindowWidth(window.innerWidth - 400);
      };

      window.addEventListener("resize", resizeHandler);
      return () => {
        window.removeEventListener("resize", resizeHandler);
      };
    }, []);

    return windowWidth;
  }

  const handleConfirm = evt => {
    evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      data: {
        selected: selected,
        option1: option1 === "" ? null : option1,
        option2: option2 === "" ? null : option2,
        option3: option3 === "" ? null : option3,
        option4: option4 === "" ? null : option4,
        option1Save: option1Save === "" ? null : option1Save,
        option2Save: option2Save === "" ? null : option2Save,
        option3Save: option3Save === "" ? null : option3Save,
        option4Save: option4Save === "" ? null : option4Save,
        user: currentUser.userName
      }
    };

    axios("/api/v1/data/select", requestOptions)
      .then(response => response.data)
      .then(
        result => {
          setModal(false);
          setIcon("far fa-question-circle");
          if (option2Save !== "" && option3Save === "") {
            axios(
              "/api/v1/table/" +
                option2Save +
                "/pagination?PageNumber=" +
                currentPage2 +
                "&PageSize=" +
                pageSize
            )
              .then(response => response.data)
              .then(
                result => {
                  //setData(result.data);
                  setIsOpen(true);
                  var tableList = [];
                  if (result.data.length > 0) {
                    // if (result.data[0].listData[0].key !== 0) {
                    result.data.forEach(e => {
                      if (e.listData.length < 6) {
                        var l1 = [];
                        var name;
                        var target;
                        var dataId;
                        var tags;
                        var j = 0;
                        for (var i = 0; i < 6; i++) {
                          if (
                            e.listData[j] !== undefined &&
                            e.listData[j].key.toString() === year[i].value
                          ) {
                            if (e.showId === 1) {
                              l1 = l1.concat(
                                e.listData[j].value2 === null
                                  ? 0
                                  : e.listData[j].value2.toFixed(2)
                              );
                            } else if (e.showId === 2) {
                              l1 = l1.concat(e.listData[j].value);
                            }
                            name = e.name;
                            target =
                              e.typeName +
                              " " +
                              Number(e.target).toLocaleString();
                            dataId = e.dataId;
                            tags = e.tags;
                            j++;
                          } else {
                            l1 = l1.concat(0);
                            name = e.name;
                            target =
                              e.typeName +
                              " " +
                              Number(e.target).toLocaleString();
                            dataId = e.dataId;
                            tags = e.tags;
                          }
                        }

                        tableList.push([
                          name,
                          target,
                          l1[5].toLocaleString(),
                          l1[4].toLocaleString(),
                          l1[3].toLocaleString(),
                          l1[2].toLocaleString(),
                          l1[1].toLocaleString(),
                          l1[0].toLocaleString(),
                          dataId,
                          option1Save,
                          option2Save,
                          tags
                        ]);
                      } else {
                        if (e.showId === 1 || e.showId === 3) {
                          tableList.push([
                            e.name,
                            e.typeName +
                              " " +
                              Number(e.target).toLocaleString(),
                            e.listData[5] === undefined
                              ? 0
                              : e.listData[5].value2
                                  .toFixed(2)
                                  .toLocaleString(),
                            e.listData[4] === undefined
                              ? 0
                              : e.listData[4].value2
                                  .toFixed(2)
                                  .toLocaleString(),
                            e.listData[3] === undefined
                              ? 0
                              : e.listData[3].value2
                                  .toFixed(2)
                                  .toLocaleString(),
                            e.listData[2] === undefined
                              ? 0
                              : e.listData[2].value2
                                  .toFixed(2)
                                  .toLocaleString(),
                            e.listData[1] === undefined
                              ? 0
                              : e.listData[1].value2
                                  .toFixed(2)
                                  .toLocaleString(),
                            e.listData[0] === undefined
                              ? 0
                              : e.listData[0].value2
                                  .toFixed(2)
                                  .toLocaleString(),
                            e.dataId,
                            option1Save,
                            option2Save,
                            e.tags
                          ]);
                        } else if (e.showId === 2 || e.showId === 4) {
                          tableList.push([
                            e.name,
                            e.typeName +
                              " " +
                              Number(e.target).toLocaleString(),
                            e.listData[5] === undefined
                              ? 0
                              : e.listData[5].value.toLocaleString(),
                            e.listData[4] === undefined
                              ? 0
                              : e.listData[4].value.toLocaleString(),
                            e.listData[3] === undefined
                              ? 0
                              : e.listData[3].value.toLocaleString(),
                            e.listData[2] === undefined
                              ? 0
                              : e.listData[2].value.toLocaleString(),
                            e.listData[1] === undefined
                              ? 0
                              : e.listData[1].value.toLocaleString(),
                            e.listData[0] === undefined
                              ? 0
                              : e.listData[0].value.toLocaleString(),
                            e.dataId,
                            option1Save,
                            option2Save,
                            e.tags
                          ]);
                        }
                      }
                    });
                    // } else {
                    //   tableList.push([
                    //     result.data[0].name,
                    //     result.data[0].typeName + " " + result.data[0].target,
                    //     0,
                    //     0,
                    //     0,
                    //     0,
                    //     0,
                    //     0,
                    //     result.data[0].dataId,
                    //     option1Save,
                    //     option2Save,
                    //     result.data[0].tags
                    //   ]);
                    // }
                  }

                  axios(
                    "/api/v1/checkReport?group1=" +
                      option1Save +
                      "&group2=" +
                      option2Save +
                      "&group3=" +
                      option3Save +
                      "&group4=" +
                      option4Save,
                    {
                      method: "GET"
                    }
                  )
                    .then(response => response.data)
                    .then(
                      result => {
                        var list = [];
                        if (
                          result.data.reportSub !== null &&
                          result.data.reportSub.length > 0
                        ) {
                          result.data.reportSub.forEach(e => {
                            list.push([e.dataId]);
                          });
                          setSelect(result.data.reportSub);
                        }
                      },
                      error => {
                        console.log(error);
                      }
                    );

                  setData2(tableList);
                  var total = result.total / pageSize;
                  if (!Number.isInteger(total)) {
                    setTotalPages2((total | 0) + 1);
                  } else if (total === 0) {
                    setTotalPages2(1);
                  } else {
                    setTotalPages2(total);
                  }
                },
                error => {
                  console.log(error);
                }
              );
          } else if (option3Save !== "" && option4Save === "") {
            axios(
              "/api/v1/table2/" +
                option3Save +
                "/pagination?PageNumber=" +
                currentPage2 +
                "&PageSize=" +
                pageSize
            )
              .then(response => response.data)
              .then(
                result => {
                  setIsOpen(true);
                  //setData(result.data);
                  var tableList = [];
                  if (result.data.length > 0) {
                    // if (result.data[0].listData[0].key !== 0) {
                    result.data.forEach(e => {
                      if (e.listData.length < 6) {
                        var l1 = [];
                        var name;
                        var target;
                        var dataId;
                        var j = 0;
                        for (var i = 0; i < 6; i++) {
                          if (
                            e.listData[j] !== undefined &&
                            e.listData[j].key.toString() === year[i].value
                          ) {
                            if (e.showId === 1) {
                              l1 = l1.concat(
                                e.listData[j].value2 === null
                                  ? 0
                                  : e.listData[j].value2.toFixed(2)
                              );
                            } else if (e.showId === 2) {
                              l1 = l1.concat(e.listData[j].value);
                            }
                            name = e.name;
                            target =
                              e.typeName +
                              " " +
                              Number(e.target).toLocaleString();
                            dataId = e.dataId;
                            j++;
                          } else {
                            l1 = l1.concat(0);
                            name = e.name;
                            target =
                              e.typeName +
                              " " +
                              Number(e.target).toLocaleString();
                            dataId = e.dataId;
                            tags = e.tags;
                          }
                        }

                        tableList.push([
                          name,
                          target,
                          l1[5].toLocaleString(),
                          l1[4].toLocaleString(),
                          l1[3].toLocaleString(),
                          l1[2].toLocaleString(),
                          l1[1].toLocaleString(),
                          l1[0].toLocaleString(),
                          dataId,
                          option1Save,
                          option2Save,
                          option3Save
                        ]);
                      } else {
                        if (e.showId === 1 || e.showId === 3) {
                          tableList.push([
                            e.name,
                            e.typeName +
                              " " +
                              Number(e.target).toLocaleString(),
                            e.listData[5] === undefined
                              ? 0
                              : e.listData[5].value2
                                  .toFixed(2)
                                  .toLocaleString(),
                            e.listData[4] === undefined
                              ? 0
                              : e.listData[4].value2
                                  .toFixed(2)
                                  .toLocaleString(),
                            e.listData[3] === undefined
                              ? 0
                              : e.listData[3].value2
                                  .toFixed(2)
                                  .toLocaleString(),
                            e.listData[2] === undefined
                              ? 0
                              : e.listData[2].value2
                                  .toFixed(2)
                                  .toLocaleString(),
                            e.listData[1] === undefined
                              ? 0
                              : e.listData[1].value2
                                  .toFixed(2)
                                  .toLocaleString(),
                            e.listData[0] === undefined
                              ? 0
                              : e.listData[0].value2
                                  .toFixed(2)
                                  .toLocaleString(),
                            e.dataId,
                            option1Save,
                            option2Save,
                            option3Save
                          ]);
                        } else if (e.showId === 2 || e.showId === 4) {
                          tableList.push([
                            e.name,
                            e.typeName +
                              " " +
                              Number(e.target).toLocaleString(),
                            e.listData[5] === undefined
                              ? 0
                              : e.listData[5].value.toLocaleString(),
                            e.listData[4] === undefined
                              ? 0
                              : e.listData[4].value.toLocaleString(),
                            e.listData[3] === undefined
                              ? 0
                              : e.listData[3].value.toLocaleString(),
                            e.listData[2] === undefined
                              ? 0
                              : e.listData[2].value.toLocaleString(),
                            e.listData[1] === undefined
                              ? 0
                              : e.listData[1].value.toLocaleString(),
                            e.listData[0] === undefined
                              ? 0
                              : e.listData[0].value.toLocaleString(),
                            e.dataId,
                            option1Save,
                            option2Save,
                            option3Save
                          ]);
                        }
                      }
                    });
                    // } else {
                    //   tableList.push([
                    //     result.data[0].name,
                    //     result.data[0].typeName + " " + result.data[0].target,
                    //     0,
                    //     0,
                    //     0,
                    //     0,
                    //     0,
                    //     0,
                    //     result.data[0].dataId,
                    //     option1Save,
                    //     option2Save,
                    //     option3Save
                    //   ]);
                    // }
                  }

                  axios(
                    "/api/v1/checkReport?group1=" +
                      option1Save +
                      "&group2=" +
                      option2Save +
                      "&group3=" +
                      option3Save +
                      "&group4=" +
                      option4Save,
                    {
                      method: "GET"
                    }
                  )
                    .then(response => response.data)
                    .then(
                      result => {
                        var list = [];
                        if (
                          result.data.reportSub !== null &&
                          result.data.reportSub.length > 0
                        ) {
                          result.data.reportSub.forEach(e => {
                            list.push([e.dataId]);
                          });
                          setSelect(result.data.reportSub);
                        }
                      },
                      error => {
                        console.log(error);
                      }
                    );

                  setData2(tableList);
                  var total = result.total / pageSize;
                  if (!Number.isInteger(total)) {
                    setTotalPages2((total | 0) + 1);
                  } else if (total === 0) {
                    setTotalPages2(1);
                  } else {
                    setTotalPages2(total);
                  }
                },
                error => {
                  console.log(error);
                }
              );
          } else if (option4Save !== "") {
            axios(
              "/api/v1/table3/" +
                option4Save +
                "/pagination?PageNumber=" +
                currentPage2 +
                "&PageSize=" +
                pageSize
            )
              .then(response => response.data)
              .then(
                result => {
                  setIsOpen(true);
                  //setData(result.data);
                  var tableList = [];
                  if (result.data.length > 0) {
                    // if (result.data[0].listData[0].key !== 0) {
                    result.data.forEach(e => {
                      if (e.listData.length < 6) {
                        var l1 = [];
                        var name;
                        var target;
                        var dataId;
                        var j = 0;
                        for (var i = 0; i < 6; i++) {
                          if (
                            e.listData[j] !== undefined &&
                            e.listData[j].key.toString() === year[i].value
                          ) {
                            if (e.showId === 1) {
                              l1 = l1.concat(
                                e.listData[j].value2 === null
                                  ? 0
                                  : e.listData[j].value2.toFixed(2)
                              );
                            } else if (e.showId === 2) {
                              l1 = l1.concat(e.listData[j].value);
                            }
                            name = e.name;
                            target =
                              e.typeName +
                              " " +
                              Number(e.target).toLocaleString();
                            dataId = e.dataId;
                            j++;
                          } else {
                            l1 = l1.concat(0);
                            name = e.name;
                            target =
                              e.typeName +
                              " " +
                              Number(e.target).toLocaleString();
                            dataId = e.dataId;
                            tags = e.tags;
                          }
                        }

                        tableList.push([
                          name,
                          target,
                          l1[5].toLocaleString(),
                          l1[4].toLocaleString(),
                          l1[3].toLocaleString(),
                          l1[2].toLocaleString(),
                          l1[1].toLocaleString(),
                          l1[0].toLocaleString(),
                          dataId,
                          option1Save,
                          option2Save,
                          option3Save,
                          option4Save
                        ]);
                      } else {
                        if (e.showId === 1 || e.showId === 3) {
                          tableList.push([
                            e.name,
                            e.typeName +
                              " " +
                              Number(e.target).toLocaleString(),
                            e.listData[5] === undefined
                              ? 0
                              : e.listData[5].value2
                                  .toFixed(2)
                                  .toLocaleString(),
                            e.listData[4] === undefined
                              ? 0
                              : e.listData[4].value2
                                  .toFixed(2)
                                  .toLocaleString(),
                            e.listData[3] === undefined
                              ? 0
                              : e.listData[3].value2
                                  .toFixed(2)
                                  .toLocaleString(),
                            e.listData[2] === undefined
                              ? 0
                              : e.listData[2].value2
                                  .toFixed(2)
                                  .toLocaleString(),
                            e.listData[1] === undefined
                              ? 0
                              : e.listData[1].value2
                                  .toFixed(2)
                                  .toLocaleString(),
                            e.listData[0] === undefined
                              ? 0
                              : e.listData[0].value2
                                  .toFixed(2)
                                  .toLocaleString(),
                            e.dataId,
                            option1Save,
                            option2Save,
                            option3Save,
                            option4Save
                          ]);
                        } else if (e.showId === 2 || e.showId === 4) {
                          tableList.push([
                            e.name,
                            e.typeName +
                              " " +
                              Number(e.target).toLocaleString(),
                            e.listData[5] === undefined
                              ? 0
                              : e.listData[5].value.toLocaleString(),
                            e.listData[4] === undefined
                              ? 0
                              : e.listData[4].value.toLocaleString(),
                            e.listData[3] === undefined
                              ? 0
                              : e.listData[3].value.toLocaleString(),
                            e.listData[2] === undefined
                              ? 0
                              : e.listData[2].value.toLocaleString(),
                            e.listData[1] === undefined
                              ? 0
                              : e.listData[1].value.toLocaleString(),
                            e.listData[0] === undefined
                              ? 0
                              : e.listData[0].value.toLocaleString(),
                            e.dataId,
                            option1Save,
                            option2Save,
                            option3Save,
                            option4Save
                          ]);
                        }
                      }
                    });
                    // } else {
                    //   tableList.push([
                    //     result.data[0].name,
                    //     result.data[0].typeName + " " + result.data[0].target,
                    //     0,
                    //     0,
                    //     0,
                    //     0,
                    //     0,
                    //     0,
                    //     result.data[0].dataId,
                    //     option1Save,
                    //     option2Save,
                    //     option3Save,
                    //     option4Save
                    //   ]);
                    // }
                  }

                  axios(
                    "/api/v1/checkReport?group1=" +
                      option1Save +
                      "&group2=" +
                      option2Save +
                      "&group3=" +
                      option3Save +
                      "&group4=" +
                      option4Save,
                    {
                      method: "GET"
                    }
                  )
                    .then(response => response.data)
                    .then(
                      result => {
                        var list = [];
                        if (
                          result.data.reportSub !== null &&
                          result.data.reportSub.length > 0
                        ) {
                          result.data.reportSub.forEach(e => {
                            list.push([e.dataId]);
                          });
                          setSelect(result.data.reportSub);
                        }
                      },
                      error => {
                        console.log(error);
                      }
                    );

                  setData2(tableList);
                  var total = result.total / pageSize;
                  if (!Number.isInteger(total)) {
                    setTotalPages2((total | 0) + 1);
                  } else if (total === 0) {
                    setTotalPages2(1);
                  } else {
                    setTotalPages2(total);
                  }
                },
                error => {
                  console.log(error);
                }
              );
          }
        },
        error => {
          alert(error);
        }
      );
  };

  // function handleSelected(selectedPage) {
  //   setSelectedPage(selectedPage);
  // }
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary" stats icon>
            <CardIcon color="primary">
              <Icon>
                <AddBox />
              </Icon>
            </CardIcon>
            <p className={classes2.cardCategory}>กรุณาเลือก</p>
            <h3 className={classes2.cardTitle}>
              หน่วยงานที่ต้องการเพิ่มตัวชี้วัดจากหน่วยงานอื่น <small></small>
            </h3>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <TSSelect
                  zIndex={999}
                  options={l1OptionSave}
                  onChange={e => setOption1Save(e)}
                />
              </GridItem>
            </GridContainer>
            <div style={{ paddingTop: "10px" }}></div>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <TSSelect
                  zIndex={998}
                  options={l2OptionSave}
                  onChange={e => setOption2Save(e)}
                  disabled={disable1Save}
                  defaulfAdd={isCheck4()}
                />
              </GridItem>
            </GridContainer>
            <div style={{ paddingTop: "10px" }}></div>
            {(option1Save === 1 || option1Save === 4) && (
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TSSelect
                    zIndex={997}
                    options={l3OptionSave}
                    onChange={e => setOption3Save(e)}
                    disabled={disable2Save}
                    defaulfAdd={isCheck5()}
                  />
                </GridItem>
              </GridContainer>
            )}
            <div style={{ paddingTop: "10px" }}></div>
            {option1Save === 4 && (
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TSSelect
                    zIndex={996}
                    options={l4OptionSave}
                    onChange={e => setOption4Save(e)}
                    disabled={disable3Save}
                    defaulfAdd={isCheck6()}
                  />
                </GridItem>
              </GridContainer>
            )}
            <div style={{ paddingTop: "10px" }}></div>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}></GridItem>
            </GridContainer>

            <GridContainer>
              {/* Confirm */}
              <Modal toggle={() => setModal(false)} isOpen={modal}>
                <div className="modal-header justify-content-center">
                  <div>
                    <i
                      className={icon}
                      style={{ color: "blue", fontSize: "2em" }}
                    ></i>
                  </div>
                </div>
                <ModalBody>
                  <p
                    style={{
                      textAlign: "center"
                    }}
                  >
                    {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                      ? "ยืนยันการบันทึกข้อมูล"
                      : "กำลังตรวจสอบข้อมูล"}
                  </p>
                  <p> </p>
                </ModalBody>
                <div className="modal-footer">
                  <Button
                    color="primary"
                    type="button"
                    onClick={() => setModal(false)}
                  >
                    <h4>ยกเลิก</h4>
                  </Button>

                  <Button
                    color="primary"
                    type="button"
                    onClick={handleConfirm}
                    disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                  >
                    <h4>ยืนยัน</h4>
                  </Button>
                </div>
              </Modal>
            </GridContainer>
          </CardBody>
          {/* <CardFooter>
          </CardFooter> */}
        </Card>
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <h4 className={classes.cardTitleWhite}>รายการตัวชี้วัด</h4>
            <p className={classes.cardCategoryWhite}>
              รายการตัวชี้วัดทั้งหมดที่มีในหน่วยงานและที่เพิ่มจากหน่วยงานอื่น
            </p>
          </CardHeader>
          <CardBody>
            {!isLoading2 && (
              <Table1
                tableHeaderColor="primary"
                tableHead={tableHead2}
                tableData={data2}
              />
            )}
            {isLoading2 && (
              <div style={{ textAlign: "center" }}>
                <img style={{ width: "20%" }} src={loading} alt="..." />
              </div>
            )}
          </CardBody>
          <CardFooter>
            {/* <PaginationComponent
              totalItems={50}
              pageSize={10}
              onSelect={handleSelected}
            /> */}
            <Pagination
              current={currentPage2}
              total={totalPages2}
              onPageChange={setCurrentPage2}
              maxWidth={windowWidth}
            />
          </CardFooter>
        </Card>
      </GridItem>
      {isOpen && (
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary" stats icon>
              <CardIcon color="primary">
                <Icon>
                  <Subject />
                </Icon>
              </CardIcon>
              <p className={classes2.cardCategory}>กรุณาเลือก</p>
              <h3 className={classes2.cardTitle}>
                หน่วยงานเพื่อเลือกตัวชี้วัด<small></small>
              </h3>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TSSelect
                    zIndex={999}
                    options={l1Option}
                    onChange={e => setOption1(e)}
                  />
                </GridItem>
              </GridContainer>
              <div style={{ paddingTop: "10px" }}></div>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TSSelect
                    zIndex={998}
                    options={l2Option}
                    onChange={e => setOption2(e)}
                    disabled={disable1}
                    defaulfAdd={isCheck()}
                  />
                </GridItem>
              </GridContainer>
              <div style={{ paddingTop: "10px" }}></div>
              {(option1 === 1 || option1 === 4) && (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <TSSelect
                      zIndex={997}
                      options={l3Option}
                      onChange={e => setOption3(e)}
                      disabled={disable2}
                      defaulfAdd={isCheck2()}
                    />
                  </GridItem>
                </GridContainer>
              )}
              <div style={{ paddingTop: "10px" }}></div>
              {option1 === 4 && (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <TSSelect
                      zIndex={996}
                      options={l4Option}
                      onChange={e => setOption4(e)}
                      disabled={disable3}
                      defaulfAdd={isCheck3()}
                    />
                  </GridItem>
                </GridContainer>
              )}
              <div style={{ paddingTop: "10px" }}></div>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}></GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      )}
      {isOpen && (
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>รายการตัวชี้วัด</h4>
              <p className={classes.cardCategoryWhite}>
                ให้เลือกตัวชี้วัดที่ต้องการแล้วกดบันทึก
                หากต้องการลบตัวชี้วัดที่เคยเพิ่มให้ติ๊กออกแล้วกดบันทึก
              </p>
            </CardHeader>
            <CardBody>
              {!isLoading && (
                <Table
                  tableHeaderColor="primary"
                  tableHead={tableHead}
                  tableData={data}
                  select={onSelected}
                  tableSelect={select}
                />
              )}
              {isLoading && (
                <div style={{ textAlign: "center" }}>
                  <img style={{ width: "20%" }} src={loading} alt="..." />
                </div>
              )}
            </CardBody>
            <CardFooter style={{ textAlign: "center" }}>
              {/* <PaginationComponent
              totalItems={50}
              pageSize={10}
              onSelect={handleSelected}
            /> */}
              <Pagination
                current={currentPage}
                total={totalPages}
                onPageChange={setCurrentPage}
                maxWidth={windowWidth}
              />
              {isShow && (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <Button color="primary" onClick={handleSubmit}>
                      <h4>บันทึก</h4>
                    </Button>
                  </GridItem>
                </GridContainer>
              )}
            </CardFooter>
          </Card>
        </GridItem>
      )}
    </GridContainer>
  );
}
